import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

// 分页穿梭框
import krryTransfer from 'krry-transfer'

import '@/styles/index.scss' // global css

// 分页组件
import Pagination from "@/components/Pagination";

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './assets/iconfont/iconfont.css'

import { Swipe, SwipeItem, Lazyload } from 'vant'
import VideoPlayer from 'vue-video-player'

import { parseTime, parseUrl, resetForm } from '@/utils/utils'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

// 全局组件挂载
Vue.component('Pagination', Pagination)

Vue.use(VideoPlayer)
const hls =require("videojs-contrib-hls")

Vue.use(hls)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import * as filters from './filters' // global filters

//import permission from '@/directive/permission/index.js' // 权限判断指令

import Print from '@/utils/print' // 打印

Vue.use(Print)
Vue.use(krryTransfer)

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

//Vue.directive('permission', permission)

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.parseUrl = parseUrl
Vue.prototype.resetForm = resetForm
Vue.prototype.parseTime = parseTime

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
